<template>
  <b-container
    v-if="(content.listePdf && content.listePdf['@nodes'].length > 0) || content.texteRegle"
    fluid
    class="d-flex justify-content-center m-0 px-0 px-md-4"
  >
    <b-row class="w-100 bordure">
      <b-col
        cols="12"
        class="titre-liste graphik_black px-2 px-sm-4 px-md-0 px-lg-2"
        :class="{ zoneEscamotableCliquable: !$isMobile() }"
      >
        <div
          v-b-toggle="regleUid"
          class="texte-regles px-1 py-2 px-lg-0"
          @click="collapsed = !collapsed"
        >
          {{ $t('messageComponent.regle') }}
          <svg-icon
            :icon-name="collapsed ? 'icone-plus-pale' : 'icone-moins-pale'"
            class="icone ml-1"
          />
        </div>
      </b-col>

      <b-collapse :id="regleUid" visible class="regle-de-jeux container-collapse w-100">
        <div
          class="col-md-10 col-lg-8 mx-auto px-3 px-sm-5 p-md-3 pt-2"
          :class="{ 'col-xl-12': idFamille }"
        >
          <div v-if="content.texteRegle" v-html="content.texteRegle" />
          <template v-if="content.listePdf">
            <div
              v-for="(item, index) in content.listePdf['@nodes']"
              :key="item"
              :class="{ 'pb-3': content.listePdf['@nodes'].length !== index }"
            >
              <Hyperlien
                v-if="content.listePdf[item].pdf.metadata"
                class="themeClair"
                :content="getContentHyperlien(item)"
              />
            </div>
          </template>
        </div>
      </b-collapse>
    </b-row>
  </b-container>
</template>

<script>
import Hyperlien from '@/components/base/Hyperlien';

export default {
  name: 'JeuCasinoRegle',
  components: { Hyperlien },
  props: {
    content: { type: Object, required: true },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          poid: 'Ko',
          regle: 'Règles du jeu',
          telecharger: 'Télécharger les règles',
        },
      },
      en: {
        messageComponent: {
          poid: 'KB',
          regle: 'Game rules',
          telecharger: 'Download the rules',
        },
      },
    },
  },
  data() {
    return {
      collapsed: false,
    };
  },
  computed: {
    regleUid() {
      return this._uid.toString();
    },
    idFamille() {
      // Si on a 2 paramètres (famille/produit) alors on a une famille (CED)
      return this.$route.params.param2 ? this.$route.params.param1 : null;
    },
  },
  methods: {
    getContentHyperlien(item) {
      let texte = this.content.listePdf[item].texteLien || this.$t('messageComponent.telecharger');
      const poidFichier = (this.content.listePdf[item].pdf.metadata.fileSize / 1000).toFixed(0);
      texte += ` [${poidFichier} ${this.$t('messageComponent.poid')}]`;
      return {
        texte,
        type: 'lienAsset',
        lien: {
          nomIcone: 'ic-share',
          cacherPoidsFichier: 'false',
          field: 'lienInterneAsset',
          lienInterneAsset: this.content.listePdf[item].pdf,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.bouton-telecharger {
  border: 3px solid #010e2a;
  border-radius: 30px;
  background-color: #fdfe8b;
  color: #010e2a;
}
.bordure {
  border: 1px solid lightgray;
  border-left: none;
  border-right: none;
}
.icone {
  vertical-align: -0.1rem;
  width: 1rem;
  height: 1rem;
}
.titre-liste {
  color: $noir-casino;
  font-size: 1.1rem;
}
.zoneEscamotableCliquable {
  &:hover {
    background-color: #f4f4f4;
  }
  &:focus-visible {
    background-color: $bleu-pale-casino;
    outline: none;
  }
}
.collapse ::v-deep a.btn {
  margin-bottom: 0;
}
@include media-breakpoint-up(md) {
  .titre-liste {
    font-size: 1.25rem;
  }
}
@include media-breakpoint-down(sm) {
  .icone {
    float: right;
  }
  .regle-de-jeux ::v-deep p {
    padding-bottom: 1rem;
  }
}
.texte-regles {
  font-size: $font-size-8;
  line-height: $line-height-11;
  @include media-breakpoint-up(sm) {
    font-size: $font-size-9;
    line-height: $line-height-12;
  }
}
ul {
  margin-left: 1rem;
}
</style>
